import { render } from "./ActDashboardMockup.vue?vue&type=template&id=6b0a360e&scoped=true"
import script from "./ActDashboardMockup.vue?vue&type=script&lang=js"
export * from "./ActDashboardMockup.vue?vue&type=script&lang=js"

import "./ActDashboardMockup.vue?vue&type=style&index=0&id=6b0a360e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0a360e"]])

export default __exports__